import { useState } from 'react'

/** Per-device convenience only (view choice, last location) - never a source of truth read back
 *  by the server. Wrapped in try/catch: can throw or silently no-op in a private window, with
 *  blocked storage, etc. - the page must work fine without it. */
export function useLocalStorage<T>(key: string, initial: T): [T, (value: T) => void] {
  const [value, setValue] = useState<T>(() => {
    try {
      const raw = window.localStorage.getItem(key)
      return raw !== null ? (JSON.parse(raw) as T) : initial
    } catch {
      return initial
    }
  })

  const set = (next: T) => {
    setValue(next)
    try {
      window.localStorage.setItem(key, JSON.stringify(next))
    } catch {
      // Ignore - per-device convenience only, see file comment.
    }
  }

  return [value, set]
}
